<vw-header-padding-safe-area></vw-header-padding-safe-area>

<div class="px-4 pb-28">
  <div class="flex items-center gap-2 pb-4">
    <button
      type="button"
      class="-ml-2 flex h-9 w-9 items-center justify-center rounded-full text-[#062825]"
      (click)="goBack()"
      [attr.aria-label]="'common.back' | translate"
    >
      <svg viewBox="0 0 24 24" class="h-6 w-6" fill="none" aria-hidden="true">
        <path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
    <h2 class="text-[28px] font-semibold text-[#062825]">
      {{ 'weather.detail.title' | translate }}
    </h2>
  </div>

  @if (isLoading) {
    <vw-skeleton-loader [width]="'100%'" [height]="'140px'" [borderRadius]="'0.75rem'"></vw-skeleton-loader>
  } @else if (failed || !days.length) {
    <p class="py-10 text-center text-sm text-[#9BA6A1]">
      {{ 'weather.detail.unavailable' | translate }}
    </p>
  } @else {

  <!-- Ce qu'il faut retenir, avant le détail -->
  <div class="flex gap-2">
    <div class="flex-1 rounded-2xl bg-white px-3 py-3 shadow-sm">
      <p class="text-[11px] uppercase tracking-wide text-[#9BA6A1]">
        {{ 'weather.detail.dry-streak' | translate }}
      </p>
      <p class="mt-0.5 text-2xl font-semibold text-[#062825]">
        {{ outlook.dryStreak }}<span class="ml-1 text-sm font-normal text-[#617069]">{{ 'weather.detail.days' | translate }}</span>
      </p>
    </div>
    <div class="flex-1 rounded-2xl bg-white px-3 py-3 shadow-sm">
      <p class="text-[11px] uppercase tracking-wide text-[#9BA6A1]">
        {{ 'weather.detail.upcoming-rain' | translate }}
      </p>
      <p class="mt-0.5 text-2xl font-semibold text-[#062825]">
        {{ outlook.upcomingRainMm }}<span class="ml-1 text-sm font-normal text-[#617069]">mm</span>
      </p>
    </div>
  </div>

  @if (nextNotableDay; as notable) {
    <div
      class="mt-2 flex items-center gap-2.5 rounded-2xl px-3 py-2.5"
      [style.background-color]="style(notable.condition).bg"
    >
      <span class="text-xl">{{ style(notable.condition).emoji }}</span>
      <p class="text-sm" [style.color]="style(notable.condition).ink">
        {{ 'weather.detail.next.' + notable.condition | translate: { day: notable.weekday + ' ' + notable.dayNumber } }}
      </p>
    </div>
  }

  <!-- La fenêtre, jour par jour -->
  <h3 class="mt-6 pb-2 text-lg font-semibold text-[#062825]">
    {{ 'weather.detail.window' | translate }}
  </h3>

  <div class="flex flex-col gap-2">
    @for (day of days; track day.date) {
      <div
        class="flex items-center gap-3 rounded-2xl px-3 py-2.5"
        [style.background-color]="style(day.condition).bg"
        [class.opacity-60]="day.isPast"
      >
        <!-- Date -->
        <div class="w-11 shrink-0 text-center">
          <p class="text-[11px] uppercase text-[#617069]">{{ day.weekday }}</p>
          <p class="text-base font-semibold" [style.color]="style(day.condition).ink">
            {{ day.dayNumber }}
          </p>
        </div>

        <span class="text-xl shrink-0">{{ style(day.condition).emoji }}</span>

        <div class="min-w-0 flex-1">
          <p class="text-sm font-medium" [style.color]="style(day.condition).ink">
            {{ 'weather.detail.conditions.' + day.condition | translate }}
            @if (day.isToday) {
              <span class="ml-1 text-[11px] font-normal">· {{ 'weather.detail.today' | translate }}</span>
            }
          </p>
          <div class="mt-0.5 flex items-center gap-3 text-[11px] text-[#617069]">
            <span>{{ day.tempMin ?? '—' }}° / {{ day.tempMax ?? '—' }}°</span>
            <span>{{ day.precipitation ?? 0 }} mm</span>
            @if (day.windSpeed && day.windSpeed >= 30) {
              <span>{{ day.windSpeed }} km/h</span>
            }
          </div>
        </div>

        <!-- Pluie, en proportion du jour le plus arrosé de la fenêtre :
             une échelle absolue rendrait toutes les barres invisibles une
             semaine sèche. -->
        <div class="flex h-9 w-2.5 shrink-0 items-end overflow-hidden rounded-full bg-white/60">
          <div
            class="w-full rounded-full transition-all"
            [style.height.%]="rainHeight(day)"
            [style.background-color]="style(day.condition).bar"
          ></div>
        </div>
      </div>
    }
  </div>

  <p class="mt-4 text-xs leading-relaxed text-[#9BA6A1]">
    {{ 'weather.detail.footnote' | translate }}
  </p>
  }
</div>
